import {useSelector} from 'react-redux'
import {RootState} from '../../../../redux/store'

export function MenuInner() {
  const currentUser = useSelector((state: RootState) => state.authSlice.user)

  return (
    <div className='d-flex align-items-center'>
      {currentUser && (
        <span className='fs-2 fw-semibold text-primary-dark'>Bienvenido, {currentUser.name}</span>
      )}
    </div>
  )
}
